import * as Yup from "yup"
import { DAY_ORDER } from "constants"

export const MIN_TOTAL_SLOTS = 0
export const MAX_TOTAL_SLOTS = 10

export const FIELDS_NAME = {
   DAILY_CONFIGURATION: "dailyConfiguration",
}
export const initialValues = {
   [FIELDS_NAME.DAILY_CONFIGURATION]: DAY_ORDER.map(d => ({
      day: d.key,
      premiumSlots: 0,
      regularSlots: 0,
   })),
}
export const validationSchema = Yup.object({
   [FIELDS_NAME.DAILY_CONFIGURATION]: Yup.array().of(
      Yup.object({
         premiumSlots: Yup.number()
            .min(0, "Premium Slots can not be negative")
            .max(
               MAX_TOTAL_SLOTS,
               `Premium Slots can not be greater than ${MAX_TOTAL_SLOTS}`
            )
            .required(),
         regularSlots: Yup.number()
            .min(0, "Regular Slots can not be negative")
            .max(
               MAX_TOTAL_SLOTS,
               `Regular Slots can not be greater than ${MAX_TOTAL_SLOTS}`
            )
            .required(),
      }).test(
         "total-match",
         `The sum of Premium & Regular slots can not be less than ${MAX_TOTAL_SLOTS}.`,
         v =>
            v.premiumSlots + v.regularSlots <= MAX_TOTAL_SLOTS &&
            v.premiumSlots + v.regularSlots >= MIN_TOTAL_SLOTS
      )
   ),
})
